import React from 'react';

/**
 * Navigation tabs for terminal sections
 */
const TerminalNav = ({ activeSection, setActiveSection, onCTFClick }) => {
  const tabs = [
    { id: 'about', label: 'about.txt' },
    { id: 'experience', label: 'experience/' },
    { id: 'education', label: 'education/' },
    { id: 'certifications', label: 'certs/' },
    { id: 'skills', label: 'skills/' },
    { id: 'htb', label: '🎯 HTB' },
    { id: 'contact', label: 'contact.txt' }
  ];

  return (
    <div className="terminal-nav">
      {tabs.map(tab => (
        <button
          key={tab.id}
          className={`nav-tab ${activeSection === tab.id ? 'active' : ''}`}
          onClick={() => setActiveSection(activeSection === tab.id ? null : tab.id)}
          style={tab.id === 'htb' ? {
            background: 'linear-gradient(135deg, rgba(159, 239, 0, 0.2) 0%, rgba(0, 100, 0, 0.2) 100%)',
            border: '1px solid #9fef00',
            color: '#9fef00'
          } : undefined}
        >
          {tab.label}
        </button>
      ))}
      {/* External: the reports site. It was only reachable by typing
          `research`, which nobody discovers on their own. */}
      <a
        className="nav-tab nav-tab-external"
        href="https://c4sh3r.dev"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="nav-research"
      >
        🔎 research/
      </a>
      <button 
        className="nav-tab ctf-button" 
        onClick={onCTFClick}
      >
        🚩 CTF
      </button>
    </div>
  );
};

export default TerminalNav;
